<template>
  <div>
    <v-card>
      <s-crud
        :title="'Consolidado de marcaciones'"
        searchInput
        item-key="Line"
        dense
        fixed-header
        @rowSelected="rowSelected"
        :config="configHoursWorked"
        @getDataRefresh="onDataRefresh"
        :filter="filter"
        :loading="loading"
        ref="SCache"
        :get-row-class="getRowClass"
      >
        <template v-slot:options>
          <!-- Botón toggle formato horas/decimal -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                small
                elevation="0"
                @click="toggleTimeFormat"
                :color="showTimeFormat ? 'blue darken-4' : 'grey darken-1'"
              >
                <v-icon x-small>
                  {{ showTimeFormat ? "mdi-clock-outline" : "mdi-numeric" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              showTimeFormat ? "Mostrar en decimal" : "Mostrar en formato hora"
            }}</span>
          </v-tooltip>

          <!-- ✅ BOTÓN PARA EXPORTAR A EXCEL -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" small elevation="0" @click="reportExcel()">
                <v-icon color="green darken-4" x-small> mdi mdi-table-clock </v-icon>
              </v-btn>
            </template>
            <span>Exportar reporte horas</span>
          </v-tooltip>
        </template>
        <template v-slot:filter>
          <v-container fluid class="filter-container">
            <v-card-text>
              <v-row dense class="filter-content">
                <!-- Primera fila: Campaña y Planilla -->
                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-briefcase</v-icon
                    >
                    <s-select-campaign-se
                      label="Campaña"
                      v-model="filter.CmpID"
                      clearable
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>

                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-clipboard-list</v-icon
                    >
                    <s-select-definition
                      :def="1060"
                      label="Planilla"
                      v-model="filter.TypePayroll"
                      clearable
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>

                <!-- Segunda fila: Área y Turno -->
                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-domain</v-icon
                    >
                    <s-select-area
                      label="Área"
                      v-model="filter.AreID"
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>

                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-clock-outline</v-icon
                    >
                    <s-select-definition
                      :def="1278"
                      label="Turno"
                      v-model="filter.TypeTurn"
                      clearable
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-clock-outline</v-icon
                    >
                    <s-date
                      label="Fecha Inicio"
                      v-model="filter.InitDate"
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <div class="filter-group">
                    <v-icon class="field-icon" color="primary" size="20"
                      >mdi-clock-outline</v-icon
                    >
                    <s-date
                      label="Fecha Fin"
                      v-model="filter.EndDate"
                      outlined
                      dense
                      class="elevated-field"
                    />
                  </div>
                </v-col>
                <!-- Sección de trabajador -->
                <v-col cols="12">
                  <v-divider class="my-3"></v-divider>
                  <h4 class="section-title">
                    <v-icon left color="primary">mdi-account</v-icon>
                    Información del Trabajador
                  </h4>
                </v-col>

                <v-col cols="12">
                  <div class="worker-section">
                    <div class="worker-input">
                      <v-icon class="field-icon" color="primary" size="20"
                        >mdi-card-account-details</v-icon
                      >
                      <s-toolbar-person
                        class="flex-grow-1"
                        noCamera
                        label="Trabajador (DNI)"
                        noEdit
                        v-model="filter.PrsDocumentNumber"
                        @returnPerson="returnPerson($event)"
                        outlined
                        dense
                      />
                      <v-btn icon color="error" @click="clearPerson()" class="clear-btn">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>

                    <div class="worker-name mt-3">
                      <v-icon class="field-icon" color="primary" size="20"
                        >mdi-account-circle</v-icon
                      >
                      <s-text
                        disabled
                        label="Nombre Completo"
                        v-model="NtpFullName"
                        outlined
                        dense
                        class="name-field"
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </template>
        <template v-slot:HoursWorked="{ row }">
          <span>
            {{ formatHourValue(row.HoursWorked) }}
          </span>
        </template>
        <template v-slot:HoursRequired="{ row }">
          <div v-if="isTimeColumn('HoursRequired')">
            <span :style="getColorToNumber(row.HoursRequired)">
              {{ formatHourValue(row.HoursRequired) }}</span
            >
          </div>
        </template>
        <template v-slot:HoursHoliday="{ row }">
          <span :style="getColorToNumber(row.HoursHoliday)">
            {{ formatHourValue(row.HoursHoliday) }}
          </span>
        </template>
        <template v-slot:HoursContingency="{ row }">
          <span :style="getColorToNumber(row.HoursContingency)">
            {{ formatHourValue(row.HoursContingency) }}
          </span>
        </template>
        <template v-slot:HoursBreak="{ row }">
          <span>
            {{ formatHourValue(row.HoursBreak) }}
          </span>
        </template>
        <template v-slot:H_NETA="{ row }">
          <span>
            {{ formatHourValue(row.H_NETA) }}
          </span>
        </template>
        <template v-slot:additional="{ row }">
          <span :style="getColorToNumber(calculateAdditional(row))">
            {{ formatHourValue(calculateAdditional(row)) }}
          </span>
        </template>
        <template v-slot:HoursExtra="{ row }">
          <span :style="row.HoursExtra">
            {{ formatHourValue(row.HoursExtra) }}
          </span>
        </template>
        <template v-slot:HoursExtra25="{ row }">
          <span :style="row.HoursExtra25">
            {{ formatHourValue(row.HoursExtra25) }}
          </span>
        </template>
        <template v-slot:HoursExtra35="{ row }">
          <span :style="row.HoursExtra35">
            {{ formatHourValue(row.HoursExtra35) }}
          </span>
        </template>
        <template v-slot:HoursExtraNight35="{ row }">
          <span :style="row.HoursExtraNight35">
            {{ formatHourValue(row.HoursExtraNight35) }}
          </span>
        </template>
        <template v-slot:HoursExtraDouble="{ row }">
          <span :style="row.HoursExtraDouble">
            {{ formatHourValue(row.HoursExtraDouble) }}
          </span>
        </template>
        <template v-slot:HoursExtraNightDouble="{ row }">
          <span :style="row.HoursExtraNightDouble">
            {{ formatHourValue(row.HoursExtraNightDouble) }}
          </span>
        </template>
        <template v-slot:HoursExtraNight25="{ row }">
          <span :style="row.HoursExtraNight25">
            {{ formatHourValue(row.HoursExtraNight25) }}
          </span>
        </template>
        <template v-slot:HoursNight="{ row }">
          <span :style="row.HoursNight">
            {{ formatHourValue(row.HoursNight) }}
          </span>
        </template>
        <template v-slot:body.append="{ headers }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              style="font-weight: bold; text-align: center"
            >
              <template v-if="header.value === 'HoursRequired'">
                <span :style="getColorToNumber(totalRequired)">
                  {{ formatHourValue(totalRequired.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursWorked'">
                <span :style="getColorToNumber(totalHoursWorked)">
                  {{ formatHourValue(totalHoursWorked.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'H_NETA'">
                <span :style="getColorToNumber(totalNeto)">
                  {{ formatHourValue(totalNeto.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursBreak'">
                <span :style="getColorToNumber(totalRef)">
                  {{ formatHourValue(totalRef.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'additional'">
                <span :style="getColorToNumber(totalAdditional)">
                  {{ formatHourValue(totalAdditional.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursHoliday'">
                <span :style="getColorToNumber(totalHoursHoliday)">
                  {{ formatHourValue(totalHoursHoliday.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtra'">
                <span :style="getColorToNumber(totalHoursExtra)">
                  {{ formatHourValue(totalHoursExtra.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtra25'">
                <span :style="getColorToNumber(totalHoursExtra25)">
                  {{ formatHourValue(totalHoursExtra25.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtra35'">
                <span :style="getColorToNumber(totalHoursExtra35)">
                  {{ formatHourValue(totalHoursExtra35.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtraDouble'">
                <span :style="getColorToNumber(totalHoursExtraDouble)">
                  {{ formatHourValue(totalHoursExtraDouble.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursNight'">
                <span :style="getColorToNumber(totalHoursNight)">
                  {{ formatHourValue(totalHoursNight.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtraNight25'">
                <span :style="getColorToNumber(totalHoursNight25)">
                  {{ formatHourValue(totalHoursNight25.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtraNight35'">
                <span :style="getColorToNumber(totalHoursNight35)">
                  {{ formatHourValue(totalHoursNight35.toFixed(2)) }}
                </span>
              </template>
              <template v-if="header.value === 'HoursExtraNightDouble'">
                <span :style="getColorToNumber(totalHoursNightDouble)">
                  {{ formatHourValue(totalHoursNightDouble.toFixed(2)) }}
                </span>
              </template>
              <template v-else> &nbsp; </template>
            </td>
          </tr>
        </template>
      </s-crud>
      <schedule-detail-modal
        v-model="dialogScheduleDetailModal"
        :schedule-data="scheduleDetailData"
        :dialog-name="scheduleDetailDialogName"
        @saved="onScheduleDetailSaved"
        @close="dialogScheduleDetailModal = false"
      />
      <markings-by-date-modal
        v-model="dialogMarking"
        :markings="MarkingsByDate"
        :headers="Markingheaders"
        :schedule-date="item?.ScheduleDate"
        :status-options="statusOptions"
        @open-reconsideration="openReconsiderationModal"
        @save="onSaveMarkings"
      />
      <reconsideration-modal
        v-if="showReconsiderationModal"
        :detail="selectedMarkingDetail"
        :history="reconsiderationHistory"
        :visible.sync="showReconsiderationModal"
        @refresh="onSaveMarkings"
        @close="showReconsiderationModal = false"
      />
      <ErrorDialog
        v-model="showErrorDialog"
        :items="errorItems"
        :headers="errorHeaders"
        title="Inconsistencias detectadas"
        message="Se encontraron inconsistencias en las marcaciones. Revise antes de continuar."
        @close="showErrorDialog = false"
      />
      <Loader v-if="loading" />
    </v-card>
  </div>
</template>
<script>
import _sMarkingService from "@/services/HumanResource/HmnMarkingService";
import _sHmnHoursWorkedService from "@/services/HumanResource/HmnHoursWorkedService.js";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import _WorkService from "@/services/HumanResource/WorkerService";
import _sDefinition from "@/services/General/DefinitionService.js";
import ScheduleDetailModal from "@/components/HumanResource/ScheduleDetailModal.vue";
import MarkingsByDateModal from "@/components/HumanResource/MarkingsByDateModal.vue";
import InlineHoursEditor from "@/components/HumanResource/InlineHoursEditor.vue";
import InlineScheduleEditor from "@/components/HumanResource/InlineScheduleEditor.vue";
import WeeklyScheduleModal from "@/components/HumanResource/WeeklyScheduleModal.vue";
import sSelectWorker from "../../../components/Utils/Worker/sSelectWorker.vue";
import GenericService from "@/services/General/GenericService";
import ReconsiderationModal from "@/components/HumanResource/ReconsiderationModal.vue";
import ErrorDialog from "@/components/HumanResource/ErrorDialog.vue";
import Loader from "@/components/Layout/Loader.vue";

export default {
  components: {
    sToolbarPerson,
    ScheduleDetailModal,
    MarkingsByDateModal,
    InlineHoursEditor,
    InlineScheduleEditor,
    WeeklyScheduleModal,
    sSelectWorker,
    sToolbarPerson,
    ReconsiderationModal,
    ErrorDialog,
    Loader,
  },
  data() {
    return {
      filter: {
        CmpID: null,
        TypePayroll: 0,
        AreID: null,
        TypeTurn: 0,
        WkrID: 0,
        InitDate: null,
        EndDate: null,
      },
      dialogName: "",
      filterScheduleDetail: {
        SdwID: 0,
        WkrID: 0,
      },
      scheduleDetailData: {
        SdwID: 0,
        WkrID: 0,
      },
      scheduleDetailDialogName: "",
      configHoursWorked: {
        service: {
          pagination: _sHmnHoursWorkedService.consolidateReportP,
        },
        model: {
          CacheID: "ID",
          ScheduleDate: "date",
          WkrName: "string",
          JobTitle: "string",
          WkrAreaName: "string",
          SdwID: "number",
          HLAB: "",
          HREF: "",
          HREF_SddHourBegin: "",
          HREF_SddHourEnd: "",
          HoursRequired: "",
          HoursHoliday: "",
          HoursBreak: "number",
          HoursWorked: "number",
          HoursExtra25: "",
        },
        headers: [
          { text: "Fecha", value: "ScheduleDate", align: "center" },
          { text: "Trabajador", value: "WkrName", align: "center" },
          { text: "DNI", value: "PrsDocumentNumber", align: "center" },

          { text: "Area", value: "AreName", align: "center" },
          //{ text: "# Marcaciones", value: "CountM", align: "center" },
          // { text: "Horas BRUTAS", value: "HoursWorked", align: "center" },
          // { text: "Horas Refrig.", value: "HoursBreak", align: "center" },
          { text: "Horas NETAS", value: "H_NETA", align: "center" },
          { text: "+/-", value: "additional", align: "center" },
          { text: "Feriado/Descanso", value: "HoursHoliday", align: "center" },
          { text: "Horas Ordinarias", value: "HoursRequired", align: "center" },
          { text: "Horas 25%", value: "HoursExtra25", align: "center" },
          { text: "Horas 35%", value: "HoursExtra35", align: "center" },
          { text: "Horas dobles", value: "HoursExtraDouble", align: "center" },
          {
            text: "Horas Noct. 25%",
            value: "HoursExtraNight25",
            align: "center",
          },
          {
            text: "Horas Noct. 35%",
            value: "HoursExtraNight35",
            align: "center",
          },
          {
            text: "Horas Noct. dobles",
            value: "HoursExtraNightDouble",
            align: "center",
          },
          { text: "Horas Nocturnas", value: "HoursNight", align: "center" },
          { text: "Total Horas Extra", value: "HoursExtra", align: "center" },
          // ✅ OPCIONAL: Agregar columna de estado
          // { text: "Estado", value: "StatusGeneral", align: "center" },
        ],
        loadingText: "Cargando datos...",
      },
      Markingheaders: [
        { text: "Documento", value: "PrsDocumentNumber" },
        { text: "Trabajador", value: "NtpFullName" },
        { text: "Area", value: "AreName" },
        { text: "Hora Marcacion", value: "MrkMarking" },
        { text: "Estado Marcacion", value: "StatusMarkingName" },
        { text: "Estado", value: "MrkStatusMarking" },
      ],
      NtpFullName: "",
      PrsDocumentNumber: "",
      NtpID: 0,
      PrsID: 0,
      WkrID: 0,
      selected: [],
      item: null,
      items: [],
      headers: [],
      loading: false,
      debounceTimer: null,
      textSearch: "",
      opcionesMarcado: [],
      MarkingsByDate: [],
      dialogScheduleDetailModal: false,
      dialogMarking: false,
      statusOptions: [],
      paramsDef: {
        defID: 1527,
        dgrID: 0,
        requestID: this.$fun.getUserID(),
      },
      massUpdateHours: 8.0,
      dialogMassUpdate: false,
      loadingMassUpdate: false,
      showTimeFormat: false, //false decimal / true  formato hora
      timeColumns: [
        "HoursRequired",
        "HoursWorked",
        "HoursBreak",
        "H_NETA",
        "additional",
        "HoursHoliday",
        "HoursExtra",
        "HoursExtra25",
        "HoursExtra35",
        "HoursExtraDouble",
        "HoursNight",
        "HoursExtraNight25",
        "HoursExtraNight35",
        "HoursNightDouble",
      ],
      showReconsiderationModal: false,
      selectedMarkingDetail: null,
      reconsiderationHistory: [],
      showErrorDialog: false,
      errorItems: [],
      errorHeaders: [
        { text: "DNI", value: "DNI" },
        { text: "Trabajador", value: "Trabajador" },
        { text: "Fecha", value: "Dia" },
        { text: "Error", value: "Error", html: true },
        // { text: "Entrada", value: "Entrada" },
        // { text: "Estado Entrada", value: "Estado Entrada" },
        // { text: "Salida", value: "Salida" },
        // { text: "Estado Salida", value: "Estado Salida" },
      ],
    };
  },
  async created() {
    const [statusMarking] = await Promise.all([
      _sDefinition.definitiongroup(
        this.paramsDef.defID,
        this.paramsDef.dgrID,
        this.paramsDef.requestID
      ),
    ]);
    this.statusOptions = statusMarking.data.filter(
      (item) => item.DedAbbreviation === "E" || item.DedAbbreviation === "S"
    );
  },
  computed: {
    totalRequired() {
      return this.items.reduce((sum, item) => sum + (item.HoursRequired || 0), 0);
    },
    totalAdditional() {
      return this.items.reduce((sum, item) => sum + this.calculateAdditional(item), 0);
    },
    totalHoursHoliday() {
      return this.items.reduce((sum, item) => sum + (item.HoursHoliday || 0), 0);
    },
    totalRef() {
      return -this.items.reduce((sum, item) => sum + (item.HoursBreak || 0), 0);
    },
    totalNeto() {
      return this.items.reduce((sum, item) => sum + (this.NetHours(item) || 0), 0);
    },
    totalHoursWorked() {
      return this.items.reduce((sum, item) => sum + (item.HoursWorked || 0), 0);
    },
    totalHoursExtra() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtra || 0), 0);
    },
    totalHoursExtra25() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtra25 || 0), 0);
    },
    totalHoursExtra35() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtra35 || 0), 0);
    },
    totalHoursExtraDouble() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtraDouble || 0), 0);
    },
    totalHoursNight() {
      return this.items.reduce((sum, item) => sum + (item.HoursNight || 0), 0);
    },
    totalHoursNight25() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtraNight25 || 0), 0);
    },
    totalHoursNight35() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtraNight35 || 0), 0);
    },
    totalHoursNightDouble() {
      return this.items.reduce((sum, item) => sum + (item.HoursExtraNightDouble || 0), 0);
    },
  },
  watch: {
    "filter.InitDate"(newVal) {
      //comparar con la fecha de fin si es mayor , tomar la fecha de fin
      if (newVal && this.filter.EndDate) {
        const startDate = this.$moment(newVal, this.$const.FormatDateDB);
        const endDate = this.$moment(this.filter.EndDate, this.$const.FormatDateDB);
        if (startDate.isAfter(endDate)) {
          this.filter.EndDate = startDate.format(this.$const.FormatDateDB);
        }
      }
    },
    "filter.EndDate"(newVal) {
      //comparar con la fecha de inicio si es menor , tomar la fecha de inicio
      if (newVal && this.filter.InitDate) {
        const startDate = this.$moment(this.filter.InitDate, this.$const.FormatDateDB);
        const endDate = this.$moment(newVal, this.$const.FormatDateDB);
        if (endDate.isBefore(startDate)) {
          this.filter.InitDate = endDate.format(this.$const.FormatDateDB);
        }
      }
    },
  },
  methods: {
    async reportExcel() {
      if (!this.filter.InitDate || !this.filter.EndDate) {
        this.$fun.alert("Debe seleccionar un rango de fechas", "warning");
        return;
      }

        // Llama al servicio que retorna los datos a exportar
        this.filter.Validate = 2;
        _sHmnHoursWorkedService
          .HoursWorked_ReportExcel(this.filter, this.$fun.getUserID())
          .then((r) => {
            this.$fun.downloadFile(
              r.data,
              this.$const.TypeFile.EXCEL,
              "Reporte_H_Trabajadas"
            );
          })
          .catch((err) => {
            console.error("Error al exportar a Excel:", err);
            this.$fun.alert("Error al exportar el reporte", "error");
          });
    },
    async returnPerson(person) {
      if (!person || !person.PrsID) {
        this.$fun.alert("Debe seleccionar un trabajador", "warning");
        return;
      }
      this.filter.PrsID = person.PrsID;
      this.filter.PrsDocumentNumber = person.PrsDocumentNumber;
      this.filter.WkrID = person.WkrID;
      this.NtpFullName = person.NtpFullName;
      this.PrsDocumentNumber = person.PrsDocumentNumber;
      this.NtpID = person.NtpID;
      this.PrsID = person.PrsID;

      try {
        const detailResponse = await _WorkService.DetailByNtpID(
          person.NtpID,
          this.$fun.getUserID()
        );
        this.filter.WkrID = detailResponse.data.WkrID || 0;
      } catch (error) {
        //console.error("Error cargando datos del trabajador:", error);
        this.$fun.alert("Error al cargar los datos del trabajador", "error");
      }

      // Refrescar datos del componente principal
      if (this.$refs.SCache && this.$refs.SCache.refresh) {
        this.$refs.SCache.refresh();
      }
    },
    clearPerson() {
      this.filter.PrsID = 0;
      this.filter.PrsDocumentNumber = "";
      this.filter.WkrID = 0;
      this.NtpFullName = "";
      this.PrsDocumentNumber = "";
      this.NtpID = 0;
      this.PrsID = 0;

      // Refrescar datos del componente principal
      if (this.$refs.SCache && this.$refs.SCache.refresh) {
        this.$refs.SCache.refresh();
      }
    },

    // ✅ CALLBACK CUANDO SE GUARDA EN EL MODAL DE DETALLE
    onScheduleDetailSaved(data) {
      //console.log("Datos guardados en el modal de horarios:", data);
      //this.onUpdateCache(data);
      //this.$refs.SCache.refresh();
    },
    async openScheduleDetail() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.$fun.alert("Debe seleccionar un registro", "warning");
        return;
      }

      // ✅ GENERAR SEMANA COMPLETA basada en la fecha del registro seleccionado
      const selectedDate = this.$moment(this.item.ScheduleDate);

      // Calcular lunes de esa semana (inicio)
      const dayOfWeek = selectedDate.day(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
      const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Si es domingo, retroceder 6 días
      const monday = selectedDate.clone().subtract(mondayOffset, "days");
      const sunday = monday.clone().add(6, "days");

      const weekStartDate = monday.format(this.$const.FormatDateDB);
      const weekEndDate = sunday.format(this.$const.FormatDateDB);

      // ✅ ACTUALIZAR FILTROS DEL COMPONENTE PADRE
      this.filter.InitDate = weekStartDate;
      this.filter.EndDate = weekEndDate;

      // ✅ ESPERAR UN POCO PARA QUE LOS PROPS SE ACTUALICEN
      await this.$nextTick();

      this.dialogScheduleDetail = true;
    },

    getMarkingIcon(detailType) {
      const cleanStatus = detailType ? detailType.trim() : "";
      const iconMap = {
        LABOR: "mdi-account-hard-hat",
        REFRIGERIO: "mdi-coffee",
        RECONSIDER: "mdi mdi-update",
      };
      return iconMap[cleanStatus] || "mdi-clock-outline";
    },
    getMarkingColor(estado) {
      switch (estado) {
        case "LABOR":
          return "green";
        case "REFRIGERIO":
          return "orange";
        case "RECONSIDER":
          return "#2436DB";
        default:
          return "grey";
      }
    },
    onDataRefresh(data) {
      // Itera sobre el array de datos original y modifica cada item
      data.forEach((item) => {
        if (item.Details && typeof item.Details === "string") {
          try {
            // Reemplaza la cadena JSON con el array de objetos parseado
            item.Details = JSON.parse(item.Details).map((detail) => ({
              ...detail,
              BeginDateTime: detail.BeginDateTime,
              EndDateTime: detail.EndDateTime,
              ValidationStatus: item.StatusGeneral == "Validado" ? 2 : 0,
            }));
            // console.log("Detalles parseados correctamente:", item.Details, item);
          } catch (e) {
            //console.error("Error al parsear los detalles JSON:", e);
            item.Details = []; // Asigna un array vacío en caso de error
            this.$fun.alert("Error al procesar los detalles de marcaciones", "error");
          }
        } else if (!item.Details) {
          item.Details = []; // Asegúrate de que Details sea un array si no existe
        }
      });

      // Actualiza la copia local que usas para los totales
      this.items = data;
    },
    calculateAdditional(item) {
      const difference = item.H_NETA - item.HoursRequired;
      const roundedDifference = parseFloat(difference.toFixed(2));
      return roundedDifference;
    },
    getColorToNumber(value) {
      if (value > 0) return "color: #388e3c; font-weight: bold;"; // verde
      if (value < 0) return "color: #d32f2f; font-weight: bold;"; // rojo
      return "color: #1976d2; font-weight: bold;"; // azul para 0
    },
    NetHours(item) {
      if (item && typeof item.H_NETA !== "undefined") {
        return parseFloat(item.H_NETA);
      }
      // Fallback al cálculo manual si no viene del SP
      if (item && item.HoursWorked && item.HoursBreak) {
        return parseFloat(item.HoursWorked - item.HoursBreak);
      }
      return 0;
    },
    async onSaveMarkings() {
      // Si el modal de marcaciones está abierto, recarga los detalles
      if (this.dialogMarking && this.item) {
        // Llama al servicio para obtener los detalles actualizados
        this.dialogMarking = false;
      }

      this.$refs.SCache.refresh();
    },
    onUpdateCache({ WkrID }) {
      this.$fun
        .alert(
          "al actualizar los datos del trabajadors, se reiniciaran los detalles y las reconsideraciones se perderan. esta seguro de seguir?",
          "question"
        )
        .then(async (resp) => {
          if (!resp.value) return; // Si el usuario cancela, no hacer nada

          this.loading = true;
          _sHmnHoursWorkedService
            .updateCache(
              WkrID,
              this.filter.InitDate,
              this.filter.EndDate,
              this.$fun.getUserID()
            )
            .finally(() => {
              this.loading = false;
              this.$refs.SCache.refresh();
              this.$fun.alert("Cache actualizado correctamente", "success");
            });
        });
    },
    rowSelected(item) {
      if (item && item.length > 0) {
        this.item = item[0];
      } else {
        this.item = null;
      }
    },
    async openScheduleDetail() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.$fun.alert("Debe seleccionar un registro", "warning");
        return;
      }

      this.dialogName = `Horarios: ${this.item.NtpFullName}`;
      this.filterScheduleDetail = {
        WkrID: this.item.WkrID,
        SdwID: this.item.SdwID,
      };

      this.dialogScheduleDetail = true;
    },
    getDayAbbr(date) {
      const d = new Date(date);
      let jsDay = d.getDay(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
      jsDay = jsDay === 0 ? 7 : jsDay; // 7=Domingo
      const found = this.$const.Days.find((day) => day.value === jsDay);
      return found ? found.abrv : "";
    },
    formatDayHour(date) {
      const abbr = this.getDayAbbr(date);
      //tiempo formato 24
      const time = new Date(date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      return `${abbr}-${time}`;
    },
    floatNumber(value) {
      return parseFloat(value).toFixed(2);
    },
    getRowClass(item) {
      if (item.CountE !== item.CountS) {
        return "incomplete-row";
      }
      return "";
    },
    toggleTimeFormat() {
      this.showTimeFormat = !this.showTimeFormat;
      // Guardar preferencia en localStorage
      localStorage.setItem("personalMarkings_timeFormat", this.showTimeFormat);
      this.$forceUpdate(); // Forzar re-render de la tabla
    },

    formatHourValue(value, forceDecimal = false) {
      if (!value && value !== 0) return "0.00";

      const numValue = parseFloat(value);
      if (isNaN(numValue)) return "0.00";

      // Si está en modo decimal o se fuerza decimal
      if (!this.showTimeFormat || forceDecimal) {
        return numValue.toFixed(2);
      }

      // Convertir a formato hh:mm:ss
      const isNegative = numValue < 0;
      const absoluteValue = Math.abs(numValue);

      const totalMinutes = Math.round(absoluteValue * 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      //sacar segundos
      const seconds = Math.round((absoluteValue * 3600) % 60);

      const timeFormatted = `${hours
        .toString()
        .padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

      return isNegative ? `-${timeFormatted}` : timeFormatted;
    },

    // Método helper para saber si una columna es de tiempo
    isTimeColumn(columnValue) {
      return this.timeColumns.includes(columnValue);
    },
    async openReconsiderationModal(detail) {
      this.showReconsiderationModal = false;

      // Extrae fecha y hora en local para entrada y salida
      const getDate = (val) => {
        if (!val) return "";
        const d = typeof val === "string" ? new Date(val) : val;
        if (isNaN(d.getTime())) return "";
        return `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
      };
      const getTime = (val) => {
        if (!val) return "";
        const d = typeof val === "string" ? new Date(val) : val;
        if (isNaN(d.getTime())) return "";
        return `${d
          .getHours()
          .toString()
          .padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
      };

      this.selectedMarkingDetail = {
        ...detail,
        BeginDate: getDate(detail.BeginDateTime),
        BeginTime: getTime(detail.BeginDateTime),
        EndDate: getDate(detail.EndDateTime),
        EndTime: getTime(detail.EndDateTime),
      };
      // return
      this.showReconsiderationModal = true;
      await this.refreshReconsiderationHistory();
    },
    async refreshReconsiderationHistory() {
      if (!this.selectedMarkingDetail) return;
      const res = await _sHmnHoursWorkedService.getReconsiderationHistory(
        this.selectedMarkingDetail.CacheDetailID,
        this.$fun.getUserID()
      );
      this.reconsiderationHistory = res.data || [];
      //refrescar el scrud
      if (this.$refs.SCache && this.$refs.SCache.refresh) {
        this.$refs.SCache.refresh();
      }
    },
    async validateRows() {
      if (!this.items || this.items.length === 0) {
        this.$fun.alert("No hay datos para validar", "warning");
        return;
      }
      //console.log("Validando filas con filtro:", this.filter);

      try {
        this.loading = true;
        const response = await _sHmnHoursWorkedService.validateRows(
          this.filter,
          this.$fun.getUserID()
        );
        this.errorItems = response.data || [];
        if (this.errorItems.length > 0) {
          // formatear la fecha
          this.errorItems = this.errorItems.map((item) => ({
            ...item,
            Dia: item.Dia ? this.$moment(item.Dia).format("DD/MM/YYYY") : "",
            // Entrada: item.Entrada
            //   ? this.$moment(item.Entrada).format("HH:mm:ss")
            //   : "",
            // Salida: item.Salida
            //   ? this.$moment(item.Salida).format("HH:mm:ss")
            //   : "",
          }));
          this.showErrorDialog = true;
        } else {
          this.$fun.alert("Validacion completa", "success");
          this.$refs.SCache.refresh();
        }
      } catch (error) {
        console.error("Error al validar consolidado:", error);
        //this.$fun.alert("Error al validar consolidado", "error");
      } finally {
        this.loading = false;
      }
    },
    async SyncDay(row) {
      this.$fun
        .alert("Esta seguro de sincronizar el dia?", "question")
        .then(async (resp) => {
          if (!resp.value) return;
          try {
            this.loading = true;
            const response = await _sHmnHoursWorkedService.syncDay(
              row.WkrID,
              row.ScheduleDate,
              this.$fun.getUserID()
            );
            this.errorItems = response.data || [];
            if (this.errorItems.length > 0) {
              this.showErrorDialog = true;
            } else {
              this.$fun.alert("Día sincronizado correctamente", "success");
              // Refrescar el cache
              this.$refs.SCache.refresh();
            }
          } catch (error) {
            console.error("Error al sincronizar el día:", error);
            this.$fun.alert("Error al sincronizar el día", "error");
          } finally {
            this.loading = false;
          }
        });
    },
  },
};
</script>
<style scoped>
.incomplete-row {
  background-color: #ffebee !important;
  /* Rojo claro */
  color: #b71c1c !important;
  /* Texto rojo oscuro */
}
.filter-container {
  padding: 4px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100%;
}

.filter-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filter-header {
  background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 16px 16px 0 0;
  padding: 20px 24px;
}

.filter-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.filter-content {
  padding: 8px 0;
}

.filter-group {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.field-icon {
  margin-top: 24px;
  opacity: 0.7;
}

.elevated-field {
  flex: 1;
  transition: all 0.3s ease;
}

.elevated-field:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.section-title {
  color: #333;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.date-section {
  background: rgba(255, 255, 255, 0.5);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.date-navigation {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.date-inputs {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.date-field {
  min-width: 160px;
}

.date-separator {
  display: none;
}

.nav-btn {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.worker-section {
  background: rgba(255, 255, 255, 0.5);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.worker-input {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.worker-name {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.name-field {
  flex: 1;
}

.clear-btn {
  margin-top: 16px;
  background: rgba(255, 255, 255, 0.9);
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  justify-content: center;
  padding: 20px 0;
}

.action-btn {
  width: 100%;
  height: 56px;
  font-weight: 600;
  text-transform: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 960px) {
  .filter-container {
    padding: 8px;
  }

  .filter-header {
    padding: 16px 20px;
  }

  .filter-title {
    font-size: 1.1rem;
  }

  .date-navigation {
    justify-content: space-between;
  }

  .date-inputs {
    order: 2;
    width: 100%;
    justify-content: center;
    margin-top: 12px;
  }

  .nav-btn {
    order: 1;
  }

  .nav-btn:last-child {
    order: 3;
  }
}

@media (max-width: 600px) {
  .filter-card {
    border-radius: 8px;
    margin: 4px;
  }

  .filter-header {
    border-radius: 8px 8px 0 0;
    padding: 12px 16px;
  }

  .filter-title {
    font-size: 1rem;
  }

  .date-section,
  .worker-section {
    padding: 16px;
  }

  .date-inputs {
    flex-direction: column;
    align-items: stretch;
  }

  .date-separator {
    display: block;
    align-self: center;
    transform: rotate(90deg);
    margin: 8px 0;
  }

  .date-field {
    min-width: auto;
    width: 100%;
  }

  .worker-input,
  .worker-name {
    flex-direction: column;
    align-items: stretch;
  }

  .field-icon {
    margin-top: 0;
    margin-bottom: 8px;
  }

  .clear-btn {
    margin-top: 8px;
    align-self: flex-end;
  }

  .action-buttons {
    padding: 16px 0;
  }

  .action-btn {
    height: 48px;
  }
}

/* Animaciones */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.filter-card {
  animation: slideIn 0.5s ease-out;
}

/* Estados de focus mejorados */
.elevated-field:focus-within {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.2);
}

/* Hover effects para mobile */
@media (hover: none) {
  .elevated-field:hover,
  .action-btn:hover {
    transform: none;
  }
}
</style>
